import { render, staticRenderFns } from "./ZztTixianList.vue?vue&type=template&id=7d868cf4&scoped=true&"
import script from "./ZztTixianList.vue?vue&type=script&lang=js&"
export * from "./ZztTixianList.vue?vue&type=script&lang=js&"
import style0 from "./ZztTixianList.vue?vue&type=style&index=0&id=7d868cf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d868cf4",
  null
  
)

export default component.exports